import { useQuery } from '@grandvisionhq/graphql';
import '../../operations/queries/get-place-by-id.js';
import '../../operations/queries/get-stores-by-distance.js';
import '../../operations/queries/get-store-by-code.js';
import '../../operations/queries/get-store-details.js';
import '../../operations/queries/get-nearest-stores.js';
import '../../operations/queries/get-preferred-store.js';
import { GET_PREFERRED_STORE_CODE } from '../../operations/queries/get-preferred-store-code.js';
import '../../operations/queries/stores-search.js';

const useGetPreferredStoreCode = (onError)=>{
    var ref, ref1;
    const query = useQuery(GET_PREFERRED_STORE_CODE, {
        onError (error) {
            onError === null || onError === void 0 ? void 0 : onError(error, 'stores.storeDetailsRoot.preferredStoreFetch.error');
        }
    });
    var ref2;
    return {
        data: (ref2 = (ref = query.data) === null || ref === void 0 ? void 0 : (ref1 = ref.me) === null || ref1 === void 0 ? void 0 : ref1.preferredStore) !== null && ref2 !== void 0 ? ref2 : null,
        loading: query.loading,
        error: query.error
    };
};

export { useGetPreferredStoreCode as default };
//# sourceMappingURL=use-get-preferred-store-code.js.map
